var styles = {"Button":"xR6SxM6JOYE-","loading":"NCs-BISj1XU-","animateStripes":"M0LU-Rdq-MA-","alignLeft":"-Ibb742Q6ck-","primary":"TrzCxs3OEpM-","secondary":"QaWL8FLJ5Aw-","tertiary":"MhDYVRl8PUc-","action":"v-Wis6ruH-8-","destruction":"kH2lHqHWQrI-","small":"lPPuBfTJl5k-","base":"VyMJpVxCrxI-","fullWidth":"yBId-F-geAA-","asIcon":"_7RSarKLXZus-"};

export { styles as default };
//# sourceMappingURL=Button.module.css.js.map
